const XTCE_NOT_ENABLED = 'XTCE is not enabled for this tenant (beta). Ask a superadmin to enable it.';
const XTCE_UNVERIFIED = 'Could not verify XTCE access for this tenant right now. Please try again shortly.';

/** Message for a failed registry mutation; 403/503 come from the tenant `xtce` beta gate. */
export const xtceMutationErrorMessage = (err: any, fallback: string): string => {
  switch (err?.response?.status) {
    case 403:
      return XTCE_NOT_ENABLED;
    case 503:
      return XTCE_UNVERIFIED;
    default:
      return err?.response?.data?.message ?? fallback;
  }
};
